import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { HelpTitle } from "../../components/Help/HelpButton";
import StudentGuide from "../../components/Help/guides/StudentGuide";
import { HAS_FULLSCREEN_API, IS_TOUCH_DEVICE } from "../../utils/deviceDetection";

// The exam asks this device for fullscreen before its first question (ExamSession's gate): a computer.
export const ASKS_FULLSCREEN = !IS_TOUCH_DEVICE && HAS_FULLSCREEN_API;

// A student page's title with the "?" of the students' guide after it (Available exams, My attempts, an exam's page).
export function StudentTitle({ children, className = "", rowClassName = "" }) {
  const { t } = useTranslation();
  return (
    <HelpTitle
      as="h1"
      helpId="student"
      helpTitle={t("help.student.title")}
      guide={<StudentGuide computer={ASKS_FULLSCREEN} />}
      className={className}
      rowClassName={rowClassName}
    >
      {children}
    </HelpTitle>
  );
}

// "← Back to …" above a student page's card: a quiet link (44px tall on phones). `state`: the router state to hand
// on (where a result was opened from).
export function BackLink({ to, state, children, className = "" }) {
  return (
    <Link
      to={to}
      state={state}
      className={`-ml-2 inline-flex min-h-[2.75rem] items-center gap-1.5 rounded-lg px-2 text-sm font-medium text-slate-600 transition duration-200 hover:bg-slate-100 hover:text-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 sm:min-h-[2.25rem] ${className}`}
    >
      <ArrowLeftIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
      {children}
    </Link>
  );
}
